<template>
  <div style="position: relative;">
    <div class="text-right" style="position: absolute; top: 3px; right: 17px;">
      <p v-if="!processing && success" class="text-success fs-13 mb-0">
        <font-awesome-icon :icon="['far', 'check-circle']" fixed-width />
        Comentario creado
      </p>
      <p v-if="!processing && error" class="text-danger fs-13 mb-0">
        <font-awesome-icon :icon="['far', 'times-circle']" fixed-width />
        Hubo un error al crear el comentario, intente nuevamente
      </p>
    </div>
    <div class="styled-card" :class="{ 'disabled-card': isDisabled }">
      <div class="d-flex w-100">
        <b-textarea
          v-model="form.content"
          rows="2"
          max-rows="2"
          size="lg"
          :disabled="isDisabled"
          placeholder="Escriba aquí tu comentario"
          class="new-comment-textarea"
        ></b-textarea>
        <div class="d-flex flex-column justify-content-end align-items-center ml-1">
          <b-button
            id="add-comment-btn"
            variant="outline-light"
            class="float-right px-0"
            :disabled="!form.content || isDisabled"
            @click="createComment"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="font-weight-bold fs-20"
              style="color: #163D7D"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
              <path d="M6.5 12h14.5" />
            </svg>
          </b-button>
          <br>
          <font-awesome-icon
            v-if="!attachment"
            :icon="['far', 'paperclip']"
            fixed-width
            size="lg"
            style="color: #163D7D;"
            :style="{ opacity: isDisabled ? '0.65' : '1', cursor: isDisabled ? 'not-allowed' : 'pointer' }"
            @click="isDisabled ? null : $emit('openFileSelector')"
          />
          <font-awesome-icon
            v-if="attachment"
            :icon="['far', 'paperclip']"
            fixed-width
            size="lg"
            style="color: #163D7D;"
            :style="{ opacity: isDisabled ? '0.65' : '1', cursor: isDisabled ? 'not-allowed' : 'pointer' }"
            @click="isDisabled ? null : $emit('openFileSelector')"
          />
        </div>
      </div>
      <hr v-if="attachment" class="my-1">
      <div v-if="attachment" class="d-flex align-items-center justify-content-end">
        <p v-if="attachment.type == 'document'" class="text-primary mb-0 text-truncate">
          <font-awesome-icon :icon="['far', 'file-alt']" fixed-width />
          <span style="font-size: 0.9rem; font-style: italic;">{{ attachment.name }}</span>
        </p>
        <p v-else class="text-primary mb-0 text-truncate">
          <font-awesome-icon :icon="['far', 'image']" fixed-width />
          <span style="font-size: 0.9rem; font-style: italic;">{{ attachment.caption }}</span>
        </p>
        <font-awesome-icon
          :icon="['far', 'trash-alt']"
          class="text-danger ml-2"
          fixed-width
          style="cursor: pointer; white-space: nowrap;"
          @click="$emit('removeAttachment')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewCommentInput',
  props: {
    isDisabled: {
      type: Boolean,
      required: true,
      default: true
    },
    attachment: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      processing: false,
      error: false,
      success: false,
      form: {
        content: ''
      }
    }
  },
  methods: {
    createComment () {
      if (!this.form.content) return
      if (this.processing) { return }
      this.processing = true
      this.error = false
      this.success = false

      const body = {
        internal_ticket_note: { content: this.form.content }
      }
      if (this.attachment) {
        let fileBody = this.attachment.type == 'image' ? { image: this.attachment.image, caption: this.attachment.caption } : { file: this.attachment.file, name: this.attachment.name }
        body.attachment = fileBody
      }

      this.$http.post(`/api/production/internal_tickets/${this.id}/internal_ticket_notes`, body)
      .then(response => {
        this.form.content = ''
        this.$emit('onNewComment', response.data)
        this.success = true
      })
      .catch(error => {
        // console.log(error)
        this.error = true
      })
      .finally(() => {
        this.processing = false
        setTimeout(() => {
          this.success = false
          this.error = false
        }, 4000)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .styled-card {
    // display: flex;
    padding: 12px;
    border-radius: 0.7rem;
    overflow: hidden;
    // border: 2px solid #e2e8f0;
    border: 2px solid rgb(22, 61, 125);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    .form-control:focus {
      box-shadow: none;
    }
    .form-control:disabled:hover {
      cursor: not-allowed;
    }
    button {
      border: none;
    }
    textarea {
      border: none;
      background-color: transparent;
      color: #505254;
      font-size: 17px;
      padding: 5px 10px;

      &::placeholder {
        font-size: 17px;
        color: #8f979e;
      }
    }
  }

  .disabled-card {
    background-color: #e8e5e5;
  }

</style>